<template>
  <div class="gs_wrap">
    <!-- 顶部区：Tab 切换 + 查询条件 + 按钮，与数字员工页顶部一致 -->
    <div class="staff_head">
      <el-radio-group v-model="mainView" @change="onSwitchView">
        <el-radio-button label="skills">技能列表</el-radio-button>
        <el-radio-button label="runs">执行记录</el-radio-button>
      </el-radio-group>

      <!-- 技能列表筛选 -->
      <el-form v-if="mainView === 'skills'" :inline="true" :model="queryForm" class="query_form" size="small">
        <el-form-item label="名称">
          <el-input v-model="queryForm.name" placeholder="名称模糊搜索" clearable
                    style="width: 140px" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.status" placeholder="全部" clearable style="width: 100px">
            <el-option label="草稿" value="draft" />
            <el-option label="已发布" value="published" />
            <el-option label="已停用" value="retired" />
          </el-select>
        </el-form-item>
        <el-form-item label="运行时">
          <el-select v-model="queryForm.runtime" placeholder="全部" clearable style="width: 100px">
            <el-option label="python" value="python" />
            <el-option label="bash" value="bash" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 执行记录筛选 -->
      <el-form v-else :inline="true" :model="runsQuery" class="query_form" size="small">
        <el-form-item v-if="runSkillId" label="技能">
          <el-tag closable @close="clearRunSkill">{{ runSkillName || runSkillId }}</el-tag>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="runsQuery.status" placeholder="全部" clearable style="width: 100px">
            <el-option label="运行中" value="running" />
            <el-option label="成功" value="succeeded" />
            <el-option label="失败" value="failed" />
            <el-option label="超时" value="timeout" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="onRunsSearch">查询</el-button>
        </el-form-item>
      </el-form>

      <div v-if="mainView === 'skills'" class="head_actions">
        <el-button icon="el-icon-upload2" size="small" @click="openImportMd">导入 SKILL.md</el-button>
        <el-button icon="el-icon-shopping-bag-1" size="small" @click="openMarket">技能市场</el-button>
        <el-button type="primary" icon="el-icon-magic-stick" size="small" @click="openGenerate">AI 生成技能</el-button>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openAdd">手动创建</el-button>
      </div>
    </div>

    <!-- 技能列表 -->
    <template v-if="mainView === 'skills'">
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="name" label="技能名" min-width="130" show-overflow-tooltip />
        <el-table-column label="说明" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.summary || '-' }}</template>
        </el-table-column>
        <el-table-column label="运行时" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.runtime === 'python' ? '' : 'warning'">{{ scope.row.runtime }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="生成方式" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="GEN_TAG[scope.row.gen_by] || 'info'" size="small">
              {{ GEN_TEXT[scope.row.gen_by] || scope.row.gen_by }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="STATUS_TAG[scope.row.status] || 'info'" size="small">
              {{ STATUS_TEXT[scope.row.status] || scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="标签" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ (scope.row.tags || []).join('、') || '-' }}</template>
        </el-table-column>
        <el-table-column label="更新时间" width="150">
          <template slot-scope="scope">{{ fmtTime(scope.row.utime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="openTest(scope.row)">试执行</el-button>
            <el-button v-if="scope.row.status === 'draft'" type="text" size="small"
                       @click="openEdit(scope.row)">编辑</el-button>
            <!-- unverified 未通过沙箱自动验证，后端拒绝发布，前端禁用并说明原因 -->
            <el-tooltip v-if="canPublish(scope.row) && scope.row.gen_by === 'unverified'"
                        content="未通过沙箱自动验证（unverified），请编辑修复脚本后再发布" placement="top">
              <span><el-button type="text" size="small" disabled>发布</el-button></span>
            </el-tooltip>
            <el-button v-else-if="canPublish(scope.row)" type="text" size="small"
                       :loading="pubId === scope.row.g_skill_id" @click="pubFromList(scope.row)">发布</el-button>
            <el-button v-if="scope.row.status === 'published'" type="text" size="small"
                       @click="retireFromList(scope.row)">停用</el-button>
            <el-button type="text" size="small" @click="viewRuns(scope.row)">记录</el-button>
            <el-button type="text" size="small" class="danger_text" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagesize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      />
    </template>

    <!-- 执行记录 -->
    <template v-else>
      <el-table :data="runsData" v-loading="runsLoading" border>
        <el-table-column label="开始时间" width="150">
          <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
        </el-table-column>
        <el-table-column label="技能" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">{{ skillName(scope.row.skill_id) }}</template>
        </el-table-column>
        <el-table-column label="触发" width="80" align="center">
          <template slot-scope="scope">{{ TRIGGER_TEXT[scope.row.trigger] || scope.row.trigger }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag :type="RUN_TAG[scope.row.status] || 'info'" size="small">
              {{ RUN_TEXT[scope.row.status] || scope.row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="退出码" width="70" align="center">
          <template slot-scope="scope">{{ scope.row.exit_code }}</template>
        </el-table-column>
        <el-table-column label="耗时" width="90" align="right">
          <template slot-scope="scope">{{ fmtDuration(scope.row.duration_ms) }}</template>
        </el-table-column>
        <el-table-column label="输出" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.output || scope.row.error || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="70" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openRunDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleRunsSizeChange"
        @current-change="handleRunsCurrentChange"
        :current-page="runsPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="runsSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="runsTotal"
      />
    </template>

    <!-- 手动创建 / 编辑（draft 专用） -->
    <el-dialog :title="editMode === 'add' ? '手动创建技能' : '编辑技能（仅草稿）'" :visible.sync="addVisible"
               width="760px" v-dialogDrag :modal-append-to-body="false" v-if="addVisible" top="5vh">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="90px">
        <el-form-item label="技能名" prop="name">
          <el-input v-model="addForm.name" maxlength="64" placeholder="同账号下唯一" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="addForm.summary" type="textarea" :rows="2" maxlength="500" />
        </el-form-item>
        <el-form-item label="运行时">
          <el-radio-group v-model="addForm.runtime" :disabled="editMode === 'edit'">
            <el-radio label="python">python</el-radio>
            <el-radio label="bash">bash</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="网络策略">
          <el-radio-group v-model="addForm.network_policy">
            <el-radio label="deny">禁网（默认）</el-radio>
            <el-radio label="all">允许全部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="addForm.tags" placeholder="多个标签用英文逗号分隔" />
        </el-form-item>
        <el-form-item label="入参定义">
          <el-table :data="addForm.inputs" border size="mini">
            <el-table-column label="参数名" min-width="110">
              <template slot-scope="scope"><el-input v-model="scope.row.name" size="mini" placeholder="参数名" /></template>
            </el-table-column>
            <el-table-column label="说明" min-width="160">
              <template slot-scope="scope"><el-input v-model="scope.row.desc" size="mini" /></template>
            </el-table-column>
            <el-table-column label="必填" width="60" align="center">
              <template slot-scope="scope"><el-switch v-model="scope.row.required" /></template>
            </el-table-column>
            <el-table-column label="操作" width="60" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="mini" class="danger_text" @click="addForm.inputs.splice(scope.$index, 1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button size="mini" icon="el-icon-plus" class="add_input_btn"
                     @click="addForm.inputs.push({ name: '', desc: '', required: false })">添加参数</el-button>
        </el-form-item>
        <el-form-item label="SKILL.md">
          <el-input v-model="addForm.skill_md" type="textarea" :rows="3" class="mono" maxlength="8000" />
        </el-form-item>
        <el-form-item label="脚本" prop="script">
          <el-input v-model="addForm.script" type="textarea" :rows="12" class="mono"
                    placeholder="入口脚本全文（python 为 runner.py，bash 为 runner.sh），须通过静态安全扫描" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submiting" @click="submitAdd">{{ editMode === 'add' ? '创 建' : '保 存' }}</el-button>
      </div>
    </el-dialog>

    <!-- SKILL.md 导入：解析 frontmatter 后落库为草稿 -->
    <el-dialog title="导入 SKILL.md" :visible.sync="importVisible" width="760px" v-dialogDrag
               :modal-append-to-body="false" v-if="importVisible" top="5vh">
      <el-alert type="info" :closable="false" class="import_tip"
                title="支持 AgentOS / Claude 风格 SKILL.md 与 skill.zip：frontmatter 自动映射，zip 内按约定提取入口脚本；references/ 暂不导入。导入后为草稿，补充脚本后方可发布。" />
      <el-form ref="importForm" :model="importForm" :rules="importRules" label-width="96px">
        <el-form-item label="文件">
          <el-button size="small" icon="el-icon-folder-opened" @click="pickMdFile">选择 SKILL.md / skill.zip</el-button>
          <span class="md_file_name">{{ importFileName || '未选择文件（也可直接粘贴内容）' }}</span>
          <input ref="mdFile" type="file" accept=".md,.markdown,.txt,.zip" class="md_file_input" @change="onMdFileChange" />
        </el-form-item>
        <el-form-item label="技能名">
          <el-input v-model="importForm.name" maxlength="64"
                    placeholder="留空自动读取 frontmatter.name 或一级标题" />
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="importForm.summary" type="textarea" :rows="2" maxlength="500"
                    placeholder="留空自动读取 frontmatter.description" />
        </el-form-item>
        <el-form-item label="运行时">
          <el-radio-group v-model="importForm.runtime">
            <el-radio label="">自动</el-radio>
            <el-radio label="python">python</el-radio>
            <el-radio label="bash">bash</el-radio>
          </el-radio-group>
          <div class="field_tip inline">自动时按 frontmatter.runtime / 入口后缀推导，默认 python</div>
        </el-form-item>
        <el-form-item label="网络策略">
          <el-radio-group v-model="importForm.network_policy">
            <el-radio label="">自动</el-radio>
            <el-radio label="deny">禁网</el-radio>
            <el-radio label="all">允许全部</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标签">
          <el-input v-model="importForm.tags" placeholder="多个标签用英文逗号分隔，留空读取 frontmatter.tags" />
        </el-form-item>
        <el-form-item label="SKILL.md" prop="skill_md">
          <el-input v-model="importForm.skill_md" type="textarea" :rows="12" class="mono"
                    placeholder="粘贴 SKILL.md 全文（含 frontmatter）" />
        </el-form-item>
        <el-form-item label="入口脚本">
          <el-input v-model="importForm.script" type="textarea" :rows="8" class="mono"
                    placeholder="可选：SKILL.md 通常只含说明；留空先存草稿，补充脚本后才能发布" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="importVisible = false">取 消</el-button>
        <el-button type="primary" :loading="importing" @click="submitImport">导 入</el-button>
      </div>
    </el-dialog>

    <!-- 技能市场：市场源维护 + 远端条目安装 -->
    <el-dialog title="技能市场" :visible.sync="marketVisible" width="920px" v-dialogDrag
               :modal-append-to-body="false" v-if="marketVisible" :close-on-click-modal="false" top="5vh">
      <div class="market_sources">
        <div class="market_title">市场源</div>
        <el-table :data="marketSources" size="mini" border max-height="180">
          <el-table-column prop="name" label="市场源" min-width="120" show-overflow-tooltip />
          <el-table-column prop="url" label="地址" min-width="260" show-overflow-tooltip />
          <el-table-column label="类型" width="100" align="center">
            <template slot-scope="scope">{{ scope.row.type === 'skillmd' ? '单 SKILL.md' : 'JSON 索引' }}</template>
          </el-table-column>
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.last_error ? 'danger' : (scope.row.last_sync_at ? 'success' : 'info')" size="mini">
                {{ scope.row.last_error ? '异常' : (scope.row.last_sync_at ? '正常' : '待同步') }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="mini" class="danger_text" @click="delSource(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-form :inline="true" size="small" class="source_form">
          <el-input v-model="sourceForm.name" placeholder="源名称" style="width: 140px" />
          <el-input v-model="sourceForm.url" placeholder="https://.../skills.json 或 SKILL.md" style="width: 380px" />
          <el-select v-model="sourceForm.type" style="width: 120px">
            <el-option label="JSON 索引" value="json" />
            <el-option label="单 SKILL.md" value="skillmd" />
          </el-select>
          <el-button type="primary" size="small" :loading="sourceSaving" @click="addSource">添加源</el-button>
        </el-form>
        <div class="field_tip">
          JSON 索引格式：{"skills":[{"name":"技能名","summary":"说明","url":"技能文件地址","tags":["标签"]}]}，也支持顶层数组；
          条目也可内嵌 skill_md。
        </div>
      </div>

      <div class="market_list_head">
        <span class="market_title">可安装技能</span>
        <el-input v-model="marketQuery" size="small" placeholder="搜索名称 / 说明 / 标签" clearable
                  style="width: 220px" @keyup.enter.native="loadMarket" />
        <el-button size="small" :loading="marketLoading" @click="loadMarket">刷新</el-button>
      </div>
      <el-table :data="marketEntries" v-loading="marketLoading" border max-height="320">
        <el-table-column prop="name" label="技能名" min-width="150" show-overflow-tooltip />
        <el-table-column prop="summary" label="说明" min-width="220" show-overflow-tooltip />
        <el-table-column prop="source_name" label="来源" width="120" show-overflow-tooltip />
        <el-table-column label="运行时" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.runtime === 'python' ? '' : 'warning'">{{ scope.row.runtime }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="标签" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ (scope.row.tags || []).join('、') || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.installed" size="mini" type="success">已安装</el-tag>
            <el-button v-else type="text" size="small"
                       :loading="installKey === (scope.row.source_id + scope.row.entry_id)"
                       @click="installEntry(scope.row)">安装</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="marketErrors.length" class="market_errors">
        <el-alert v-for="(err, i) in marketErrors" :key="i" type="warning" :closable="false" :title="err" />
      </div>
      <div slot="footer">
        <el-button @click="marketVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- AI 生成向导（SSE，服务端 15 分钟超时） -->
    <el-dialog title="AI 生成技能" :visible.sync="genVisible" width="760px" v-dialogDrag
               :modal-append-to-body="false" v-if="genVisible" :close-on-click-modal="false"
               :before-close="onGenBeforeClose" top="5vh">
      <el-steps :active="gStep" simple>
        <el-step title="需求描述" />
        <el-step title="生成进度" />
      </el-steps>

      <div v-if="gStep === 0" class="g_step">
        <el-form ref="gForm" :model="gForm" :rules="gRules" label-width="90px">
          <el-form-item label="需求描述" prop="requirement">
            <el-input v-model="gForm.requirement" type="textarea" :rows="5" maxlength="4000" show-word-limit
                      placeholder="例：读取 CSV 中的线索列表，按最近联系时间排序并输出前 10 条" />
          </el-form-item>
          <el-form-item label="运行时" prop="runtime">
            <el-radio-group v-model="gForm.runtime">
              <el-radio label="python">python</el-radio>
              <el-radio label="bash">bash</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="技能名">
            <el-input v-model="gForm.name" maxlength="64" placeholder="留空由 AI 命名" style="width: 260px" />
          </el-form-item>
          <el-form-item label="网络策略">
            <el-radio-group v-model="gForm.network_policy">
              <el-radio label="deny">禁网（默认）</el-radio>
              <el-radio label="all">允许全部</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="标签">
            <el-input v-model="gForm.tags" placeholder="多个标签用英文逗号分隔" style="width: 260px" />
          </el-form-item>
          <el-form-item label="试执行参">
            <el-input v-model="gForm.test_inputs" type="textarea" :rows="2" class="mono"
                      placeholder='可选，JSON 字符串，如 {"lead_id":"L001"}' />
            <div v-if="gInputsErr" class="err_text">{{ gInputsErr }}</div>
          </el-form-item>
        </el-form>
      </div>

      <div v-else class="g_step">
        <div class="gen_tip">生成 → 沙箱验证 → 修复循环（最多 10 轮），全程最长 15 分钟，产物自动存为草稿</div>
        <div v-if="gProg.stages.length" class="stage_list">
          <div v-for="(s, i) in gProg.stages" :key="i" class="stage_item">
            <i :class="i < gProg.stages.length - 1 || gProg.result ? 'el-icon-success stage_ok' : 'el-icon-loading stage_run'" />
            <span>{{ s }}</span>
          </div>
        </div>
        <div v-else-if="!gProg.result && !gProg.error" class="stage_empty">正在连接…</div>
        <el-alert v-if="gProg.error && !gProg.result" type="error" :closable="false" show-icon
                  :title="gProg.error" class="gen_err_alert" />

        <el-collapse>
          <el-collapse-item :title="'思考过程' + (gProg.thinks ? '（' + gProg.thinks.length + ' 字）' : '')">
            <pre class="stream_pre">{{ gProg.thinks || '（暂无）' }}</pre>
          </el-collapse-item>
          <el-collapse-item title="生成内容（脚本流式片段）">
            <pre class="stream_pre code_view"><code>{{ gProg.reply || '（暂无）' }}</code></pre>
          </el-collapse-item>
        </el-collapse>

        <div v-if="gProg.result" class="result_card">
          <el-alert v-if="!gProg.result.verified" type="warning" :closable="false" show-icon
                    title="未通过沙箱自动验证（unverified），禁止发布，可编辑修复脚本后再发布" />
          <div class="kv"><span class="k">技能</span><span>{{ gProg.result.name || '-' }}</span></div>
          <div class="kv"><span class="k">验证</span>
            <el-tag :type="gProg.result.verified ? 'success' : 'danger'" size="small">
              {{ gProg.result.verified ? '通过' : '未通过' }}
            </el-tag>
          </div>
          <div class="kv"><span class="k">修复轮次</span><span>{{ gProg.result.rounds }}</span></div>
        </div>
      </div>

      <div slot="footer">
        <el-button v-if="gStep === 0" @click="genVisible = false">取 消</el-button>
        <el-button v-if="gStep === 0" type="primary" @click="runGenerate">开始生成</el-button>
        <el-button v-if="generating" @click="cancelGenerate">停止展示</el-button>
        <el-button v-if="gProg.result" type="primary" @click="viewGenerated">查看技能</el-button>
        <el-button v-if="gStep === 1 && !generating" @click="genVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog :title="'技能详情：' + (gSkill.name || '')" :visible.sync="detailVisible" width="900px" v-dialogDrag
               :modal-append-to-body="false" v-if="detailVisible" top="5vh">
      <div class="detail_body">
        <div class="skill_info">
          <div class="kv"><span class="k">状态</span>
            <el-tag :type="STATUS_TAG[gSkill.status] || 'info'" size="small">{{ STATUS_TEXT[gSkill.status] || gSkill.status }}</el-tag>
          </div>
          <div class="kv"><span class="k">生成方式</span>
            <el-tag :type="GEN_TAG[gSkill.gen_by] || 'info'" size="small">{{ GEN_TEXT[gSkill.gen_by] || gSkill.gen_by }}</el-tag>
            <span v-if="gSkill.repair_rounds" class="ver_meta">修复 {{ gSkill.repair_rounds }} 轮</span>
          </div>
          <div class="kv"><span class="k">运行时</span><span>{{ gSkill.runtime }}（{{ gSkill.entry || '-' }}）</span></div>
          <div class="kv"><span class="k">网络策略</span><span>{{ gSkill.network_policy === 'all' ? '允许全部' : '禁网' }}</span></div>
          <div class="kv"><span class="k">说明</span><span>{{ gSkill.summary || '-' }}</span></div>
          <div class="kv"><span class="k">标签</span><span>{{ (gSkill.tags || []).join('、') || '-' }}</span></div>
          <div class="kv"><span class="k">创建/更新</span><span>{{ fmtTime(gSkill.ctime) }} / {{ fmtTime(gSkill.utime) }}</span></div>
        </div>

        <h5>入参定义（{{ (gSkill.inputs || []).length }}）</h5>
        <el-table :data="gSkill.inputs || []" border size="mini" empty-text="无入参">
          <el-table-column prop="name" label="参数名" min-width="120" />
          <el-table-column label="说明" min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.desc || '-' }}</template>
          </el-table-column>
          <el-table-column label="必填" width="60" align="center">
            <template slot-scope="scope">{{ scope.row.required ? '是' : '否' }}</template>
          </el-table-column>
        </el-table>

        <h5>SKILL.md</h5>
        <pre class="stream_pre">{{ gSkill.skill_md || '（无）' }}</pre>

        <h5>脚本（{{ gSkill.entry || '-' }}）</h5>
        <pre class="script_pre">{{ gSkill.script || '（无）' }}</pre>
      </div>
    </el-dialog>

    <!-- 试执行（真实沙箱，同步等待最长 3 分钟） -->
    <el-dialog :title="'试执行：' + (testSkill.name || '')" :visible.sync="testVisible" width="720px" v-dialogDrag
               :modal-append-to-body="false" v-if="testVisible" top="5vh">
      <div class="kv"><span class="k">运行时</span><span>{{ testSkill.runtime }}</span></div>
      <el-form label-width="90px" style="margin-top: 8px">
        <el-form-item label="入参 JSON">
          <el-input v-model="testInputs" type="textarea" :rows="4" class="mono"
                    placeholder='JSON 字符串，无参可留空，如 {"lead_id":"L001"}' />
          <div v-if="testInputsErr" class="err_text">{{ testInputsErr }}</div>
        </el-form-item>
      </el-form>
      <div v-if="testResult" class="result_card">
        <div class="kv"><span class="k">状态</span>
          <el-tag :type="RUN_TAG[testResult.status] || 'info'" size="small">
            {{ RUN_TEXT[testResult.status] || testResult.status }}
          </el-tag>
        </div>
        <div class="kv"><span class="k">退出码</span><span>{{ testResult.exit_code }}</span></div>
        <div class="kv"><span class="k">耗时</span><span>{{ fmtDuration(testResult.duration_ms) }}</span></div>
        <div v-if="testResult.error" class="kv"><span class="k">错误</span><span class="err_text">{{ testResult.error }}</span></div>
        <h5>输出</h5>
        <pre class="stream_pre">{{ testResult.output || '（无输出）' }}</pre>
      </div>
      <div slot="footer">
        <el-button @click="testVisible = false">关 闭</el-button>
        <el-button type="primary" :loading="testRunning" @click="runTest">
          {{ testRunning ? '执行中（最长 3 分钟）…' : '执 行' }}
        </el-button>
      </div>
    </el-dialog>

    <!-- 执行记录详情（直接用行数据，字段已含全量快照） -->
    <el-dialog title="执行记录详情" :visible.sync="runDetailVisible" width="760px" v-dialogDrag
               :modal-append-to-body="false" v-if="runDetailVisible" top="5vh">
      <div class="detail_body" v-if="curRun">
        <div class="kv"><span class="k">记录 ID</span><span>{{ curRun.run_id }}</span></div>
        <div class="kv"><span class="k">技能</span><span>{{ skillName(curRun.skill_id) }}</span></div>
        <div class="kv"><span class="k">触发方式</span><span>{{ TRIGGER_TEXT[curRun.trigger] || curRun.trigger }}</span></div>
        <div class="kv"><span class="k">状态</span>
          <el-tag :type="RUN_TAG[curRun.status] || 'info'" size="small">{{ RUN_TEXT[curRun.status] || curRun.status }}</el-tag>
        </div>
        <div class="kv"><span class="k">退出码</span><span>{{ curRun.exit_code }}</span></div>
        <div class="kv"><span class="k">耗时</span><span>{{ fmtDuration(curRun.duration_ms) }}</span></div>
        <div class="kv"><span class="k">开始/结束</span><span>{{ fmtTime(curRun.ctime) }} / {{ fmtTime(curRun.utime) }}</span></div>
        <h5>入参快照</h5>
        <pre class="stream_pre">{{ curRun.inputs || '（无）' }}</pre>
        <h5 v-if="curRun.error">错误</h5>
        <pre v-if="curRun.error" class="stream_pre">{{ curRun.error }}</pre>
        <h5>输出</h5>
        <pre class="stream_pre">{{ curRun.output || '（无输出）' }}</pre>
        <h5>脚本快照</h5>
        <pre class="script_pre">{{ curRun.script_snapshot || '（无）' }}</pre>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { agentBody } from '../utils'
import { ssePost } from '../sse'

// generate SSE 的 stage 为后端固定英文 token，前端映射中文
const STAGE_TEXT = {
  generating: '生成脚本', scanning: '静态安全扫描', testing: '沙箱试执行',
  reviewing: 'LLM 审查输出', repairing: '修复脚本', done: '完成'
}
const STATUS_TEXT = { draft: '草稿', published: '已发布', retired: '已停用' }
const STATUS_TAG = { draft: 'info', published: 'success', retired: 'warning' }
// gen_by 枚举以 api-reference §9 为准（generated/manual/unverified/import/market）
const GEN_TEXT = { generated: 'AI 生成', manual: '手动', unverified: '未过验证', import: 'SKILL.md 导入', market: '市场安装' }
const GEN_TAG = { generated: 'success', manual: 'info', unverified: 'danger', import: 'warning', market: 'success' }
const RUN_TEXT = { running: '运行中', succeeded: '成功', failed: '失败', timeout: '超时' }
const RUN_TAG = { running: '', succeeded: 'success', failed: 'danger', timeout: 'warning' }
const TRIGGER_TEXT = { generate: '生成', test: '试执行', invoke: '调用' }

// 通用技能管理：列表 / 手动创建 / AI 生成(SSE) / 试执行(真实沙箱) / 发布状态机 / 执行记录；
// 个人与企业均可管理自己的技能（owner 由服务端判定）
export default {
  name: 'AiAgentGeneralSkills',
  data() {
    return {
      STATUS_TEXT, STATUS_TAG, GEN_TEXT, GEN_TAG, RUN_TEXT, RUN_TAG, TRIGGER_TEXT,
      mainView: 'skills',
      queryForm: { name: '', status: '', runtime: '' },
      tableData: [],
      loading: false,
      currentPage: 1,
      pagesize: 20,
      total: 0,
      reqSeq: 0,
      loaded: false,
      skillNameCache: {},
      // 弹窗数据请求序号：防快速切换目标时晚到响应覆盖（编辑/详情）
      editSeq: 0,
      detailSeq: 0,
      // 手动创建 / 编辑
      addVisible: false,
      editMode: 'add',
      editId: '',
      addForm: { name: '', summary: '', runtime: 'python', network_policy: 'deny', tags: '', skill_md: '', script: '', inputs: [] },
      addRules: {
        name: [{ required: true, message: '请输入技能名', trigger: 'blur' }],
        runtime: [{ required: true, message: '请选择运行时', trigger: 'change' }],
        script: [{ required: true, message: '请输入脚本内容', trigger: 'blur' }]
      },
      submiting: false,
      // SKILL.md 导入
      importVisible: false,
      importFileName: '',
      importing: false,
      importForm: { name: '', summary: '', runtime: '', network_policy: '', tags: '', skill_md: '', script: '' },
      importRules: {
        skill_md: [{ required: true, message: '请选择文件或粘贴 SKILL.md 内容', trigger: 'blur' }]
      },
      // 技能市场
      marketVisible: false,
      marketLoading: false,
      marketQuery: '',
      marketSources: [],
      marketEntries: [],
      marketErrors: [],
      installKey: '',
      sourceSaving: false,
      sourceForm: { name: '', url: '', type: 'json' },
      // 发布/停用
      pubId: '',
      // AI 生成向导
      genVisible: false,
      gStep: 0,
      gForm: { requirement: '', runtime: 'python', name: '', network_policy: 'deny', tags: '', test_inputs: '' },
      gRules: {
        requirement: [{ required: true, message: '请输入需求描述', trigger: 'blur' }],
        runtime: [{ required: true, message: '请选择运行时', trigger: 'change' }]
      },
      gInputsErr: '',
      generating: false,
      abortCtrl: null,
      gProg: { stages: [], thinks: '', reply: '', result: null, error: '' },
      // 详情
      detailVisible: false,
      gSkill: {},
      // 试执行
      testVisible: false,
      testSkill: {},
      testInputs: '',
      testInputsErr: '',
      testRunning: false,
      testResult: null,
      // 试执行请求序号：同一技能重开重跑时旧响应也会串线，skill_id 校验不够
      testSeq: 0,
      // 执行记录
      runSkillId: '',
      runSkillName: '',
      runsQuery: { status: '' },
      runsData: [],
      runsLoading: false,
      runsPage: 1,
      runsSize: 20,
      runsTotal: 0,
      runsSeq: 0,
      runDetailVisible: false,
      curRun: null
    }
  },
  methods: {
    onActivate() {
      if (!this.loaded) this.loadList()
    },
    onSwitchView() {
      // 执行记录实时性强，每次切入刷新
      if (this.mainView === 'runs') this.loadRuns()
    },
    loadList() {
      this.loading = true
      const seq = ++this.reqSeq
      const data = { page: this.currentPage, limit: this.pagesize }
      if (this.queryForm.name) data.name = this.queryForm.name
      if (this.queryForm.status) data.status = this.queryForm.status
      if (this.queryForm.runtime) data.runtime = this.queryForm.runtime
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsList, agentBody(data)).then((res) => {
        if (seq !== this.reqSeq) return
        if (res.data.code == 0) {
          this.tableData = res.data.data.data || []
          this.total = res.data.data.total || 0
          this.loaded = true
          this.tableData.forEach(s => { this.skillNameCache[s.g_skill_id] = s.name })
        }
        this.loading = false
      }).catch(() => { if (seq === this.reqSeq) this.loading = false })
    },
    onSearch() { this.currentPage = 1; this.loadList() },
    resetQuery() { this.queryForm = { name: '', status: '', runtime: '' }; this.onSearch() },
    handleSizeChange(val) { this.pagesize = val; this.loadList() },
    handleCurrentChange(val) { this.currentPage = val; this.loadList() },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    },
    fmtDuration(ms) {
      if (!ms && ms !== 0) return '-'
      return ms < 1000 ? ms + 'ms' : (ms / 1000).toFixed(1) + 's'
    },
    // skill_id → 名称：优先缓存（列表/详情回填），执行记录跨页时不退化为 id 前缀
    skillName(id) {
      if (!id) return '-'
      const hit = this.skillNameCache[id] || (this.tableData.find(x => x.g_skill_id === id) || {}).name
      return hit || id.substring(0, 16) + '…'
    },
    // 发布条件：draft/retired 可发布；unverified 后端 3001 拒绝，前端禁用按钮
    // SKILL.md 导入的技能可无脚本先存草稿，发布前必须补充入口脚本（后端同样拦截）
    canPublish(row) {
      return (row.status === 'draft' || row.status === 'retired') && !!((row.script || '').trim())
    },
    parseTags(str) {
      return (str || '').split(/[,，]/).map(s => s.trim()).filter(Boolean)
    },
    validateJsonText(text) {
      if (!text || !text.trim()) return { ok: true, val: '' }
      try {
        JSON.parse(text)
        return { ok: true, val: text }
      } catch (e) {
        return { ok: false, err: '不是合法 JSON：' + e.message }
      }
    },

    /* ---------- 手动创建 / 编辑 ---------- */
    openAdd() {
      // 使 in-flight 的编辑 get 失效：防草稿 A 的晚到响应覆盖新建表单（editMode 已是 add，会把 A 内容创建为新技能）
      ++this.editSeq
      this.editMode = 'add'
      this.editId = ''
      this.addForm = { name: '', summary: '', runtime: 'python', network_policy: 'deny', tags: '', skill_md: '', script: '', inputs: [] }
      this.addVisible = true
      this.$nextTick(() => this.$refs.addForm && this.$refs.addForm.clearValidate())
    },
    openEdit(row) {
      this.editMode = 'edit'
      this.editId = row.g_skill_id
      // 序号守卫：快速点开 A/B 草稿编辑时，丢弃 A 的晚到响应，防 A 内容提交到 B
      const seq = ++this.editSeq
      // 编辑仅草稿可进；先 get 拉最新全文，防列表数据过期
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsGet,
        agentBody({ skill_id: row.g_skill_id })).then((res) => {
        if (seq !== this.editSeq || res.data.code != 0) return
        const s = res.data.data || {}
        this.addForm = {
          name: s.name || '',
          summary: s.summary || '',
          runtime: s.runtime || 'python',
          network_policy: s.network_policy || 'deny',
          tags: (s.tags || []).join(','),
          skill_md: s.skill_md || '',
          script: s.script || '',
          inputs: (s.inputs || []).map(x => ({ ...x }))
        }
        this.addVisible = true
        this.$nextTick(() => this.$refs.addForm && this.$refs.addForm.clearValidate())
      }).catch(() => {})
    },
    submitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return
        const inputs = this.addForm.inputs.filter(x => x.name)
        const body = {
          name: this.addForm.name,
          summary: this.addForm.summary || '',
          runtime: this.addForm.runtime,
          network_policy: this.addForm.network_policy,
          tags: this.parseTags(this.addForm.tags),
          skill_md: this.addForm.skill_md || '',
          script: this.addForm.script,
          inputs
        }
        const url = this.editMode === 'add' ? this.$baseUrl.aiAgentGenSkillsAdd : this.$baseUrl.aiAgentGenSkillsEdit
        if (this.editMode === 'edit') body.skill_id = this.editId
        this.submiting = true
        this.$tools.asyncPost(this, url, agentBody(body)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: this.editMode === 'add' ? '已创建草稿' : '已保存' })
            this.addVisible = false
            this.loadList()
          }
          this.submiting = false
        }).catch((err) => {
          this.submiting = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      })
    },
    handleDel(row) {
      this.$MessageBox.confirm('删除为软删除（执行日志保留），确认删除该技能？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsDel,
          agentBody({ skill_id: row.g_skill_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '删除成功' })
            if (this.tableData.length === 1 && this.currentPage > 1) this.currentPage -= 1
            this.loadList()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },
    pubFromList(row) {
      this.$MessageBox.confirm('发布后技能可被数字员工调用，确认发布「' + row.name + '」？', '提示', { type: 'warning' }).then(() => {
        this.pubId = row.g_skill_id
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsPublish,
          agentBody({ skill_id: row.g_skill_id })).then((res) => {
          this.pubId = ''
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '发布成功' })
            this.loadList()
          }
        }).catch(() => { this.pubId = '' })
      }).catch(() => {})
    },
    retireFromList(row) {
      this.$MessageBox.confirm('停用后技能不可被数字员工调用（可再次发布恢复），确认停用？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsRetire,
          agentBody({ skill_id: row.g_skill_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已停用' })
            this.loadList()
          }
        }).catch(() => {})
      }).catch(() => {})
    },

    /* ---------- SKILL.md 导入 ---------- */
    openImportMd() {
      this.importFileName = ''
      this.importForm = { name: '', summary: '', runtime: '', network_policy: '', tags: '', skill_md: '', script: '' }
      this.importVisible = true
      this.$nextTick(() => this.$refs.importForm && this.$refs.importForm.clearValidate())
    },
    pickMdFile() {
      if (this.$refs.mdFile) this.$refs.mdFile.click()
    },
    onMdFileChange(e) {
      const file = e && e.target && e.target.files && e.target.files[0]
      if (!file) return
      // zip 走 multipart 解包导入，直接提交
      if (/\.zip$/i.test(file.name)) {
        e.target.value = ''
        this.uploadZip(file)
        return
      }
      if (file.size > 262144) {
        this.$message({ type: 'warning', message: 'SKILL.md 超过 256KB 限制' })
        e.target.value = ''
        return
      }
      const reader = new FileReader()
      reader.onload = () => {
        this.importFileName = file.name
        this.importForm.skill_md = String(reader.result || '')
        const meta = this.parseMdMeta(this.importForm.skill_md)
        if (!this.importForm.name && meta.name) this.importForm.name = meta.name
        if (!this.importForm.summary && meta.description) this.importForm.summary = meta.description
        if (!this.importForm.tags && meta.tags) this.importForm.tags = meta.tags
      }
      reader.onerror = () => this.$message({ type: 'error', message: '文件读取失败' })
      reader.readAsText(file)
      e.target.value = ''
    },
    // skill.zip：解包后按约定提取 SKILL.md 与 scripts 入口
    uploadZip(file) {
      if (file.size > 8 * 1024 * 1024) {
        return this.$message({ type: 'warning', message: '压缩包超过 8MB 限制' })
      }
      const fd = new FormData()
      fd.append('file', file)
      this.importing = true
      // multipart 必须显式声明，避免全局 application/json 头把 FormData 序列化
      this.$axios.post(this.$baseUrl.aiAgentGenSkillsImportZip, fd, {
        timeout: 120000,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((res) => {
        this.importing = false
        if (res.data.code == 0) {
          const note = (res.data.data && res.data.data.note) || ''
          this.$message({ type: 'success', message: note || '导入成功' })
          this.importVisible = false
          this.loadList()
        }
      }).catch((err) => {
        this.importing = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '上传失败，请稍后重试' })
      })
    },
    // 前端轻量预览 frontmatter（最终以服务端解析为准）
    parseMdMeta(text) {
      const out = {}
      const norm = (text || '').replace(/\r\n/g, '\n')
      const fm = /^---\n([\s\S]*?)\n---/.exec(norm)
      if (!fm) {
        const h = /^#\s+(.+)$/m.exec(norm)
        if (h) out.name = h[1].trim()
        return out
      }
      const pick = (key) => {
        const m = new RegExp('^' + key + ':\\s*(.+)$', 'm').exec(fm[1])
        return m ? m[1].trim().replace(/^["']|["']$/g, '') : ''
      }
      out.name = pick('name')
      out.description = pick('description')
      const tags = pick('tags')
      if (tags) {
        out.tags = tags.replace(/^\[|\]$/g, '').split(/[,，]\s*/)
          .map(s => s.trim().replace(/^["']|["']$/g, '')).filter(Boolean).join(',')
      }
      return out
    },
    submitImport() {
      this.$refs.importForm.validate((valid) => {
        if (!valid) return
        const body = { skill_md: this.importForm.skill_md }
        if (this.importForm.name) body.name = this.importForm.name
        if (this.importForm.summary) body.summary = this.importForm.summary
        if (this.importForm.runtime) body.runtime = this.importForm.runtime
        if (this.importForm.network_policy) body.network_policy = this.importForm.network_policy
        if (this.importForm.script) body.script = this.importForm.script
        const tags = this.parseTags(this.importForm.tags)
        if (tags.length) body.tags = tags
        this.importing = true
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsImportMd, agentBody(body)).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已导入为草稿；补充入口脚本后可发布' })
            this.importVisible = false
            this.loadList()
          }
          this.importing = false
        }).catch((err) => {
          this.importing = false
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      })
    },

    /* ---------- 技能市场 ---------- */
    openMarket() {
      this.marketVisible = true
      this.sourceForm = { name: '', url: '', type: 'json' }
      this.loadMarket()
    },
    loadMarket() {
      this.marketLoading = true
      const body = this.marketQuery ? { query: this.marketQuery } : {}
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsMarketList, agentBody(body)).then((res) => {
        if (res.data.code == 0) {
          const d = res.data.data || {}
          this.marketSources = d.sources || []
          this.marketEntries = d.entries || []
          this.marketErrors = d.errors || []
        }
        this.marketLoading = false
      }).catch(() => { this.marketLoading = false })
    },
    addSource() {
      if (!this.sourceForm.name.trim()) return this.$message({ type: 'warning', message: '请输入市场源名称' })
      if (!/^https?:\/\/\S+/.test(this.sourceForm.url.trim())) {
        return this.$message({ type: 'warning', message: '请输入 http/https 地址' })
      }
      this.sourceSaving = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsSourceAdd, agentBody({
        name: this.sourceForm.name.trim(), url: this.sourceForm.url.trim(), type: this.sourceForm.type
      })).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: '已添加市场源' })
          this.sourceForm = { name: '', url: '', type: 'json' }
          this.loadMarket()
        }
        this.sourceSaving = false
      }).catch((err) => {
        this.sourceSaving = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
      })
    },
    delSource(row) {
      this.$MessageBox.confirm('确认删除市场源「' + row.name + '」？已安装技能不受影响。', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsSourceDel,
          agentBody({ source_id: row.source_id })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已删除' })
            this.loadMarket()
          }
        }).catch(() => {})
      }).catch(() => {})
    },
    installEntry(row) {
      this.$MessageBox.confirm('将从市场安装「' + row.name + '」为草稿，确认？', '提示', { type: 'info' }).then(() => {
        this.installKey = row.source_id + row.entry_id
        this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsMarketInstall, agentBody({
          source_id: row.source_id, entry_id: row.entry_id, name: row.name
        })).then((res) => {
          this.installKey = ''
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已安装为草稿，可补充入口脚本后发布' })
            this.loadList()
            this.loadMarket()
          }
        }).catch((err) => {
          this.installKey = ''
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
        })
      }).catch(() => {})
    },

    /* ---------- AI 生成（SSE，无幂等：generating 防重复提交） ---------- */
    openGenerate() {
      // 兜底中断上一条流（正常路径弹窗关闭时 onGenBeforeClose 已 abort）
      if (this.abortCtrl) { this.abortCtrl.abort(); this.abortCtrl = null }
      this.gStep = 0
      this.gForm = { requirement: '', runtime: 'python', name: '', network_policy: 'deny', tags: '', test_inputs: '' }
      this.gInputsErr = ''
      this.gProg = { stages: [], thinks: '', reply: '', result: null, error: '' }
      this.genVisible = true
      this.$nextTick(() => this.$refs.gForm && this.$refs.gForm.clearValidate())
    },
    async runGenerate() {
      this.$refs.gForm.validate(async (valid) => {
        if (!valid) return
        // 同步重入保护：双击/旧流未清时防并发 SSE（abortCtrl 被覆盖后旧流无法取消）
        if (this.generating) return this.$message({ type: 'warning', message: '生成进行中，请勿重复提交' })
        const chk = this.validateJsonText(this.gForm.test_inputs)
        if (!chk.ok) { this.gInputsErr = chk.err; return }
        this.gInputsErr = ''
        this.gStep = 1
        this.generating = true
        this.abortCtrl = new AbortController()
        const body = {
          requirement: this.gForm.requirement,
          runtime: this.gForm.runtime,
          network_policy: this.gForm.network_policy
        }
        if (this.gForm.name) body.name = this.gForm.name
        const tags = this.parseTags(this.gForm.tags)
        if (tags.length) body.tags = tags
        if (chk.val) body.test_inputs = chk.val
        try {
          await ssePost(this.$baseUrl.aiAgentGenSkillsGenerate, body, {
            onMessage: (evt) => {
              if (evt.kind === 'stage') {
                if (evt.content === 'done') return
                // 多轮循环会重复出现 testing/repairing：相邻去重，非相邻保留以体现轮次
                const text = STAGE_TEXT[evt.content] || evt.content
                const last = this.gProg.stages[this.gProg.stages.length - 1]
                if (last !== text) this.gProg.stages.push(text)
              } else if (evt.kind === 'think') {
                this.gProg.thinks += evt.content
              } else {
                this.gProg.reply += evt.content
              }
            },
            onOk: (result) => {
              this.gProg.result = result
              if (result && result.verified === false) {
                this.$message({ type: 'warning', message: '未通过沙箱自动验证（unverified），禁止发布' })
              }
              this.loadList()
            },
            onError: (msg) => {
              // toast 之外持久化错误，防用户错过提示后界面无任何失败痕迹
              this.gProg.error = msg
              this.$message({ type: 'error', message: msg })
            },
            // generate 无 client_turn_id 幂等，断连提示不能沿用对话的"取回缓存"语义
            disconnectMsg: '连接中断；生成仍在后台进行，完成后可在列表查看产物'
          }, this.abortCtrl.signal)
        } finally {
          this.generating = false
        }
      })
    },
    cancelGenerate() {
      if (this.abortCtrl) this.abortCtrl.abort()
      this.$message({ type: 'info', message: '已停止展示进度；后端仍会继续执行并入库，稍后刷新列表可见产物' })
    },
    // 弹窗关闭（X/Esc/遮罩）：abort 使 ssePost 静默返回，旧任务的回调不再污染下次向导
    onGenBeforeClose(done) {
      if (this.abortCtrl) this.abortCtrl.abort()
      done()
    },
    viewGenerated() {
      if (this.gProg.result && this.gProg.result.skill_id) {
        this.genVisible = false
        this.openDetail({ g_skill_id: this.gProg.result.skill_id })
      }
    },

    /* ---------- 详情 ---------- */
    openDetail(row) {
      // 序号守卫：快速开关 A/B 详情时，丢弃 A 的晚到响应
      const seq = ++this.detailSeq
      this.detailVisible = true
      this.gSkill = {}
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsGet,
        agentBody({ skill_id: row.g_skill_id })).then((res) => {
        if (seq !== this.detailSeq || res.data.code != 0) return
        this.gSkill = res.data.data || {}
        this.skillNameCache[this.gSkill.g_skill_id] = this.gSkill.name
      }).catch(() => {})
    },

    /* ---------- 试执行（真实沙箱，同步等待） ---------- */
    openTest(row) {
      ++this.testSeq // 作废 in-flight 响应：跨技能与同技能重开两种串线统一由序号收敛
      this.testSkill = row
      this.testResult = null
      this.testInputsErr = ''
      this.testRunning = false
      // 有入参定义时生成模板 JSON，减少手写成本
      if (row.inputs && row.inputs.length) {
        const tpl = {}
        row.inputs.forEach(x => { tpl[x.name] = '' })
        this.testInputs = JSON.stringify(tpl, null, 2)
      } else {
        this.testInputs = ''
      }
      this.testVisible = true
    },
    runTest() {
      if (this.testRunning) return
      const chk = this.validateJsonText(this.testInputs)
      if (!chk.ok) { this.testInputsErr = chk.err; return }
      this.testInputsErr = ''
      this.testRunning = true
      const seq = ++this.testSeq
      const skillId = this.testSkill.g_skill_id
      const body = { skill_id: skillId }
      if (chk.val) body.inputs_json = chk.val
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsTest, agentBody(body)).then((res) => {
        // 序号守卫：同一技能关闭重开重跑时，旧响应也会覆盖新结果/提前解锁
        if (seq !== this.testSeq) return
        if (res.data.code == 0) {
          this.testResult = res.data.data || {}
          if (this.testResult.status !== 'succeeded') {
            this.$message({ type: 'warning', message: '执行未成功，详见结果' })
          }
        }
        this.testRunning = false
      }).catch((err) => {
        if (seq !== this.testSeq) return
        this.testRunning = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '网络异常，请稍后重试' })
      })
    },

    /* ---------- 执行记录 ---------- */
    viewRuns(row) {
      this.mainView = 'runs'
      this.runSkillId = row.g_skill_id
      this.runSkillName = row.name
      this.runsPage = 1
      this.loadRuns()
    },
    clearRunSkill() {
      this.runSkillId = ''
      this.runSkillName = ''
      this.runsPage = 1
      this.loadRuns()
    },
    loadRuns() {
      this.runsLoading = true
      const seq = ++this.runsSeq
      const data = { page: this.runsPage, limit: this.runsSize }
      if (this.runSkillId) data.skill_id = this.runSkillId
      if (this.runsQuery.status) data.status = this.runsQuery.status
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsRunsList, agentBody(data)).then((res) => {
        if (seq !== this.runsSeq) return
        if (res.data.code == 0) {
          this.runsData = res.data.data.data || []
          this.runsTotal = res.data.data.total || 0
        }
        this.runsLoading = false
      }).catch(() => { if (seq === this.runsSeq) this.runsLoading = false })
    },
    onRunsSearch() { this.runsPage = 1; this.loadRuns() },
    handleRunsSizeChange(val) { this.runsSize = val; this.loadRuns() },
    handleRunsCurrentChange(val) { this.runsPage = val; this.loadRuns() },
    // 详情先用行数据即时展示，再调 runs/get 补全快照（列表已裁剪 script_snapshot）；
    // run_id 守卫防快速切换 A/B 时 A 的晚到响应覆盖 B 的详情
    openRunDetail(row) {
      this.curRun = row
      this.runDetailVisible = true
      this.$tools.asyncPost(this, this.$baseUrl.aiAgentGenSkillsRunsGet,
        agentBody({ run_id: row.run_id })).then((res) => {
        if (res.data.code == 0 && this.curRun && this.curRun.run_id === row.run_id) {
          this.curRun = res.data.data || row
        }
      }).catch(() => {})
    }
  },
  beforeDestroy() {
    // 路由离开中断进行中的生成流（后端仍会继续执行并入库）
    if (this.abortCtrl) this.abortCtrl.abort()
  }
}
</script>

<style lang="less" scoped>
// 生成内容为脚本片段，按代码块风格展示（非 markdown）；公共样式见 code-view.less
@import '../code-view.less';
.staff_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 12px;
  margin-bottom: 10px;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-sizing: border-box;
  // Tab 切换复用单选组，样式改为与数字员工子 Tab 一致的 1px 下划线
  /deep/ .el-radio-group {
    display: inline-flex;
    align-items: center;
    height: 100%;
    flex: 0 0 auto;
  }
  /deep/ .el-radio-button {
    height: 100%;
  }
  /deep/ .el-radio-button__inner {
    height: 100%;
    line-height: 40px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none !important;
    border-bottom: 1px solid transparent;
  }
  /deep/ .el-radio-button__inner:hover {
    color: #303133;
    background: transparent;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #303133;
    background: transparent;
    border-bottom-color: #12618A;
    box-shadow: none !important;
  }
  .query_form {
    margin-left: auto;
    /deep/ .el-form-item {
      margin: 0 10px 0 0;
    }
    /deep/ .el-form-item:last-child {
      margin-right: 0;
    }
    /deep/ .el-form-item__label {
      line-height: 32px;
    }
  }
  .head_actions {
    display: flex;
    align-items: center;
    margin-left: 8px;
    .el-button + .el-button {
      margin-left: 8px;
    }
  }
}
.danger_text { color: #f56c6c; }
.g_step { margin-top: 16px; }
.gen_tip {
  font-size: 12px;
  color: #909399;
  padding: 4px 0 8px;
}
.gen_err_alert {
  margin: 8px 0;
}
.stage_list { margin: 8px 0 12px; }
.stage_item {
  padding: 4px 0;
  color: #606266;
  .stage_ok { color: #67c23a; margin-right: 6px; }
  .stage_run { color: #409eff; margin-right: 6px; }
}
.stage_empty { color: #909399; padding: 8px 0; font-size: 13px; }
.stream_pre {
  max-height: 200px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  padding: 8px;
  font-size: 12px;
  margin: 0;
}
.script_pre {
  max-height: 320px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  background: #282c34;
  color: #abb2bf;
  padding: 10px;
  font-size: 12px;
  font-family: Menlo, Consolas, monospace;
  margin: 0;
  border-radius: 4px;
}
.result_card {
  margin-top: 12px;
  .el-alert { margin-bottom: 8px; }
}
.kv {
  display: flex;
  padding: 3px 0;
  font-size: 13px;
  .k {
    width: 80px;
    flex-shrink: 0;
    color: #909399;
  }
}
.detail_body {
  max-height: 68vh;
  overflow: auto;
}
.skill_info { margin-bottom: 8px; }
h5 { margin: 12px 0 6px; font-size: 13px; color: #606266; }
.ver_meta { font-size: 12px; color: #909399; margin-left: 10px; }
.add_input_btn { margin-top: 6px; }
.mono /deep/ textarea {
  font-family: Menlo, Consolas, monospace;
  font-size: 12px;
}
.err_text { color: #f56c6c; font-size: 12px; line-height: 1.4; }

/* SKILL.md 导入 */
.import_tip { margin-bottom: 12px; }
.md_file_input { display: none; }
.md_file_name { margin-left: 10px; font-size: 12px; color: #909399; }

/* 技能市场 */
.market_sources {
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 12px;
}
.market_title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  display: inline-block;
}
.source_form {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  /deep/ .el-form-item { margin-bottom: 0; }
}
.market_list_head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  .market_title { margin-bottom: 0; flex: 1; }
}
.market_errors { margin-top: 10px; }
.market_errors .el-alert { margin-bottom: 6px; }
</style>
